import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AccountService } from '../services/account-service';
import { environment } from '../../environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if ([401, 403].includes(err.status) && this.accountService.accountValue) {
                if (this.accountService.accountValue) {
                    //if you were already logged in
                    // auto logout if 401 or 403 response returned from api 
                    this.accountService.logout();
                } else {
                    window.location.href = environment.tessellonPortalLoginUrl;
                }
            }


            const error = (err && err.error && err.error.message) || err.statusText;
            console.error(error);
            // document.location.href = environment.tessellonPortalLoginUrl;
            return throwError(() => error);
        }));
    }
}